import axiosConfigs from '../../axiosConfigs.json'
import Vue from 'vue'
import axios from 'axios'
import store from '@/store';
import router from '@/router';

// axios global
// axios.defaults.baseURL = axiosConfigs.baseURL
// axios.defaults.headers.commom['Authorization'] = 'abc123'
// axios.defaults.headers.get['Accepts'] = 'application/json'

// let headers = {
//       'Content-Type': 'application/json;charset=UTF-8',
//       "Access-Control-Allow-Origin": "*",
// };

Vue.use({
  install(Vue) {
    // axios global
    // Vue.prototype.$http = axios

    Vue.prototype.$http = axios.create({
      baseURL: axiosConfigs.baseURL,
      method: "POST"
    });

    Vue.prototype.$http.interceptors.request.use(
      config => {
        // console.log(config.data)
        config.headers.authorization = 'Bearer ' + store.getters['usuario/getToken'];
        store.commit('loader/START_LOADING');
        return config
      },
      error => {
        store.commit('loader/FINISH_LOADING');
        Promise.reject(error)
      }
    );

    Vue.prototype.$http.interceptors.response.use(
      async response => {
        // console.log(response.data)

        store.commit('loader/FINISH_LOADING');
        if (response.data.errors &&
          response.data.errors[0].message === 'jwt expired') {

          store.dispatch('usuario/logout');
          router.push('login');
          Vue.prototype.$toast.error('Acesso ao sistema expirado. É necessário fazer o Login novamente!');
        } else {

          return response
        }
      },
      error => {
        store.commit('loader/FINISH_LOADING');
        Promise.reject(error)
      }
    );

  }
})
